import { useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { isPromotionalMaterialRestricted } from "../../../shared/promotionalMaterialAccess";
import { MyUserDataContext } from "../contexts";
import { CustomClaims, RMUser } from "../types";
import { useFirestore } from "./firebaseContext";

export function useCanSendPromotionalMaterial(): boolean {
    const db = useFirestore();
    const userData = useContext(MyUserDataContext);
    const claims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims | undefined;
    const isKfhRm = claims?.kfh_rm === true;
    const email = userData.user?.email?.toLowerCase();
    const [access, setAccess] = useState<{ email: string; rm?: RMUser; failed?: boolean }>();

    useEffect(() => {
        if (!isKfhRm || !email) return;
        return onSnapshot(doc(db, "rms", email), (snapshot) => {
            setAccess({
                email,
                rm: snapshot.data() as RMUser | undefined,
            });
        }, () => setAccess({ email, failed: true }));
    }, [db, email, isKfhRm]);

    // Wait for the sender's RM record before offering the action to a KFH RM.
    return !isKfhRm || (!!email && access?.email === email && !access.failed
        && !isPromotionalMaterialRestricted(claims, access.rm));
}
